import { render, staticRenderFns } from "./ChartComponent.vue?vue&type=template&id=5f2f323a&scoped=true&"
import script from "./ChartComponent.vue?vue&type=script&lang=js&"
export * from "./ChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChartComponent.vue?vue&type=style&index=0&id=5f2f323a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f323a",
  null
  
)

export default component.exports